export default __webpack_public_path__ + "static/media/app-saludsa-app-gallery.d85c0b97.svg";